import {
  Component,
  DestroyRef,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  MatSidenav,
  MatSidenavContainer,
  MatSidenavContent,
} from '@angular/material/sidenav';
import { AuthService } from '@core/services/auth.service';
import { ServiceWorkerService } from '@core/services/service-worker.service';
import { fromEvent } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { NavComponent } from './shared/components/nav/nav.component';
import { AsyncPipe } from '@angular/common';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { BreadcrumbComponent } from './shared/components/breadcrumb/breadcrumb.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    NavComponent,
    MatSidenavContainer,
    MatSidenav,
    SidebarComponent,
    MatSidenavContent,
    BreadcrumbComponent,
    RouterOutlet,
    AsyncPipe,
  ],
})
export class AppComponent implements OnInit {
  @ViewChild('drawer', { static: true }) private leftPanel: MatSidenav;

  protected windowMode: 'large' | 'medium' | 'small' = 'medium';

  private readonly authService = inject(AuthService);

  private readonly serviceWorkerService = inject(ServiceWorkerService);

  protected isNavOpen$ = this.authService.user$.pipe(map((user) => !!user));

  private readonly destroyRef$ = inject(DestroyRef);

  ngOnInit(): void {
    this.serviceWorkerService.init();

    fromEvent(window, 'resize')
      .pipe(
        startWith(window),
        map(() => this.setWindowMode()),
        takeUntilDestroyed(this.destroyRef$)
      )
      .subscribe();
  }

  handleSidebar(isOpen: boolean): void {
    if (this.windowMode === 'large') {
      return;
    }
    if (!isOpen) {
      this.leftPanel.close();
      return;
    }
    this.leftPanel.toggle();
  }

  private setWindowMode(): void {
    const { innerWidth } = window;
    if (innerWidth >= 1400) {
      this.windowMode = 'large';
      this.leftPanel.open();
      return;
    }
    this.windowMode = 'medium';
    this.leftPanel.close();
  }
}
